export const normalizeCountryLabel = (value?: string): string => {
  if (!value) {
    return "";
  }

  const normalized = value.trim();

  if (normalized === "UAE" || normalized === "AE") {
    return "United Arab Emirates";
  }

  return normalized;
};
